import React, { useImperativeHandle, useState } from 'react'
import BaseModal from '@/component/modal/BaseModal.tsx'
import SolidButton from '@/component/button/SolidButton.tsx'
import BorderButton from '@/component/button/BorderButton.tsx'
import { useTranslation } from 'react-i18next'
import { useMutationDeleteUser } from '@/api/settings/settings.ts'
import { toast } from 'react-toastify'
import { useLoginStore } from '@/store/LoginStore.ts'

const DeleteAccountModal = (_: any, ref: any) => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    const { mutateAsync: deleteUser } = useMutationDeleteUser()
    const { logout } = useLoginStore()

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current?.show()
        }
    }))

    const modalRef = React.useRef<any>()

    const handleCancel = () => {
        modalRef.current?.close()
    }

    const handleDelete = async () => {
        setIsLoading(true)
        try {
            await deleteUser()
            toast.success(t('settings.user.deleteSuccess'))
            modalRef.current?.close()
            // 회원탈퇴 후 로그아웃 처리
            await logout()
            window.location.href = '/login'
        } catch (error) {
            toast.error(t('settings.user.deleteError'))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <BaseModal
            ref={modalRef}
            title={t('settings.user.deleteConfirmTitle')}
            width="400"
        >
            <div className="p-6 flex flex-col gap-4">
                <p className="text-base">
                    {t('settings.user.deleteConfirmMessage')}
                </p>
                <div className="flex justify-between gap-4 mt-4">
                    <BorderButton
                        text={t('changeSettingsModal.cancel')}
                        onClick={handleCancel}
                        className="flex-1"
                    />
                    <SolidButton
                        text={t('settings.user.deleteConfirm')}
                        onClick={handleDelete}
                        isLoading={isLoading}
                        className="flex-1 bg-red-500"
                    />
                </div>
            </div>
        </BaseModal>
    )
}

export default React.forwardRef(DeleteAccountModal) 